// @avantia common-code
import { SMap } from '@avantia/client-and-server-utilities';
import { HpClientAnswerMap } from './types';

export interface HpPerQuestionSetModifyAnswersProps {
  answers: HpClientAnswerMap;
  fromQuestionSetId: string;
  fromQuestionSetVersion: string;
  productId: string;
  toQuestionSetId: string;
  toQuestionSetVersion: string;
}

export interface HpPerQuestionSetConfig {
  productId: string;
  /**
   * If false, the answers loaded from the server will not be matched against the questions in the question set.
   * This means orphaned answers that do not form part of the questionSet will not be removed. This is desirable in
   * some scenarios, such as when switching between questionSets (e.g. "QuestionSet Switcher-1.0.0.0.json").
   */
  cleanAnswersOnLoad?: boolean;
  modifyAnswers?: (props: HpPerQuestionSetModifyAnswersProps) => void;
}

const registry: SMap<HpPerQuestionSetConfig> = {};

export function registerPerQuestionSetConfig(config: HpPerQuestionSetConfig): void {
  const { productId } = config;
  registry[productId] = config;
}

export interface HpGetPerQuestionSetConfigProps {
  productId: string;
}

export function getPerQuestionSetConfig({ productId }: HpGetPerQuestionSetConfigProps): HpPerQuestionSetConfig {
  return registry[productId] || {};
}
